import { DefaultTemplate, COR, CORES_SIM_NAO, CORES_PRIORIDADE } from './types';

// ============================================================
// OBRAS / ENGENHARIA — construtoras, empreiteiras e engenharia
//
// Cobre o ciclo de quem executa: planejar e tocar a obra, contratar e medir
// empreiteiro, abastecer o canteiro, segurança do trabalho e pós-obra.
// A parte de incorporadora/imobiliária está em ./imobiliario.ts.
// ============================================================

const execucaoObra: DefaultTemplate = {
  id: 'tpl_execucao_obra',
  name: 'Planejamento e Execução de Obra',
  descricao: 'Do cadastro da obra à entrega das chaves: orçamento, mobilização do canteiro, avanço físico-financeiro, vistoria de pendências e termo de entrega. O painel de quem toca obra.',
  categoria: 'obras',
  icone: '🏗️',
  etiquetas: [
    { nome: 'Obra Própria', cor: COR.azul },
    { nome: 'Cliente Terceiro', cor: COR.roxo },
    { nome: 'Prazo Crítico', cor: COR.vermelho },
    { nome: 'Aditivo em Curso', cor: COR.amarelo },
  ],
  etapas: [
    {
      id: 'ob_e1', nome: 'Cadastro e Planejamento',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['ob_c1', 'ob_c3', 'ob_c7'],
      permiteMoverPara: ['ob_e2'],
      campos: [
        { id: 'ob_c1', nome: 'Nome da Obra', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'ob_c2', nome: 'Cliente / Contratante', tipo: 'texto', obrigatorio: true },
        { id: 'ob_c3', nome: 'Tipo de Obra', tipo: 'lista', obrigatorio: true, opcoes: ['Residencial vertical', 'Residencial horizontal', 'Comercial', 'Industrial', 'Reforma / Retrofit', 'Infraestrutura', 'Loja / Varejo'], coresOpcoes: { 'Residencial vertical': COR.azul, 'Industrial': COR.cinza, 'Reforma / Retrofit': COR.amarelo } },
        { id: 'ob_c4', nome: 'Endereço da Obra', tipo: 'texto', obrigatorio: true },
        { id: 'ob_c5', nome: 'Área Construída (m²)', tipo: 'numero', obrigatorio: false },
        { id: 'ob_c6', nome: 'Engenheiro Responsável', tipo: 'texto', obrigatorio: false },
        { id: 'ob_c7', nome: 'Valor Orçado do Contrato', tipo: 'valor', obrigatorio: true },
        { id: 'ob_c8', nome: 'Data de Início Prevista', tipo: 'data', obrigatorio: true },
        { id: 'ob_c9', nome: 'Prazo de Entrega', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'ob_c10', nome: 'Orçamento / Planilha', tipo: 'anexo', obrigatorio: false },
        { id: 'ob_c11', nome: 'Cronograma Físico-Financeiro', tipo: 'anexo', obrigatorio: false },
        { id: 'ob_c12', nome: 'Escopo Resumido', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'ob_e2', nome: 'Aprovação da Diretoria',
      tempoMaximoHoras: 48,
      slaIgnorarFimDeSemana: true,
      camposVisiveisNoCard: ['ob_c1', 'ob_c7', 'ob_c13'],
      permiteMoverPara: ['ob_e3', 'ob_e8'],
      permiteCriarCards: false,
      limparCamposAoRetornar: ['ob_c13', 'ob_c15'],
      campos: [
        { id: 'ob_c13', nome: 'Obra aprovada?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ob_c14', nome: 'Margem Prevista (%)', tipo: 'numero', obrigatorio: false },
        { id: 'ob_c15', nome: 'Observações da Diretoria', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'ob_e3', nome: 'Mobilização do Canteiro',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['ob_c1', 'ob_c16', 'ob_c20'],
      permiteMoverPara: ['ob_e4', 'ob_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'ob_c16', nome: 'Itens de Mobilização', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Alvará de construção', 'ART / RRT recolhida', 'CNO aberto', 'Placa de obra', 'Ligação provisória de água/luz', 'Barracão e vestiário', 'Tapume e sinalização', 'Equipe mobilizada', 'PCMAT / PGR'] },
        { id: 'ob_c17', nome: 'Alvará de Construção', tipo: 'anexo', obrigatorio: false },
        { id: 'ob_c18', nome: 'ART / RRT', tipo: 'anexo', obrigatorio: false },
        { id: 'ob_c19', nome: 'Encarregado do Canteiro', tipo: 'texto', obrigatorio: false },
        { id: 'ob_c20', nome: 'Canteiro liberado para execução?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'ob_e4', nome: 'Execução',
      camposVisiveisNoCard: ['ob_c1', 'ob_c21', 'ob_c9'],
      permiteMoverPara: ['ob_e5', 'ob_e7'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'ob_c21', nome: 'Avanço Físico (%)', tipo: 'progresso', obrigatorio: false },
        { id: 'ob_c22', nome: 'Etapa Atual', tipo: 'lista', obrigatorio: false, opcoes: ['Fundação', 'Estrutura', 'Alvenaria', 'Instalações', 'Revestimentos', 'Esquadrias', 'Pintura', 'Acabamento final'] },
        { id: 'ob_c23', nome: 'Valor Já Medido', tipo: 'valor', obrigatorio: false },
        { id: 'ob_c24', nome: 'Custo Realizado', tipo: 'valor', obrigatorio: false },
        { id: 'ob_c25', nome: 'Aditivo de Prazo/Valor?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ob_c26', nome: 'Detalhe do Aditivo', tipo: 'texto_longo', obrigatorio: false },
        { id: 'ob_c27', nome: 'Diário de Obra / RDO', tipo: 'anexo', obrigatorio: false },
        { id: 'ob_c28', nome: 'Fotos do Avanço', tipo: 'anexo', obrigatorio: false },
        { id: 'ob_c29', nome: 'Execução concluída?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'ob_e5', nome: 'Vistoria e Pendências',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['ob_c1', 'ob_c31'],
      permiteMoverPara: ['ob_e6', 'ob_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'ob_c30', nome: 'Checklist de Vistoria', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Instalações testadas', 'Impermeabilização verificada', 'Esquadrias e vidros', 'Pintura e acabamento', 'Limpeza fina', 'Louças e metais', 'Áreas comuns', 'Documentação as built'] },
        { id: 'ob_c31', nome: 'Ficou pendência?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ob_c32', nome: 'Lista de Pendências', tipo: 'texto_longo', obrigatorio: false },
        { id: 'ob_c33', nome: 'Relatório de Vistoria', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'ob_e6', nome: 'Entrega ao Cliente',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['ob_c1', 'ob_c34', 'ob_c37'],
      permiteCriarCards: false,
      campos: [
        { id: 'ob_c34', nome: 'Data da Entrega', tipo: 'data', obrigatorio: true },
        { id: 'ob_c35', nome: 'Termo de Recebimento', tipo: 'anexo', obrigatorio: false },
        { id: 'ob_c36', nome: 'Projeto As Built', tipo: 'anexo', obrigatorio: false },
        { id: 'ob_c37', nome: 'Valor Final da Obra', tipo: 'valor', obrigatorio: false },
        { id: 'ob_c38', nome: 'Habite-se / CVCO', tipo: 'anexo', obrigatorio: false },
        { id: 'ob_c39', nome: 'Manual do Proprietário Entregue', tipo: 'checkbox_single', obrigatorio: false, opcoes: ['Entregue'] },
      ],
    },
    {
      id: 'ob_e7', nome: 'Obra Paralisada',
      camposVisiveisNoCard: ['ob_c1', 'ob_c40'],
      permiteMoverPara: ['ob_e4', 'ob_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'ob_c40', nome: 'Motivo da Paralisação', tipo: 'lista', obrigatorio: true, opcoes: ['Falta de pagamento', 'Chuva / clima', 'Falta de material', 'Falta de mão de obra', 'Embargo / fiscalização', 'Alteração de projeto', 'Decisão do cliente'], coresOpcoes: { 'Embargo / fiscalização': COR.vermelho, 'Falta de pagamento': COR.vermelho } },
        { id: 'ob_c41', nome: 'Data da Paralisação', tipo: 'data', obrigatorio: false },
        { id: 'ob_c42', nome: 'Previsão de Retomada', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'ob_c43', nome: 'Detalhamento', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'ob_e8', nome: 'Não Aprovada',
      camposVisiveisNoCard: ['ob_c1', 'ob_c44'],
      permiteMoverPara: ['ob_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'ob_c44', nome: 'Motivo da Recusa', tipo: 'texto_longo', obrigatorio: true },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Obra aprovada vai para mobilização',
      etapaOrigemId: 'ob_e2',
      condicao: { campoId: 'ob_c13', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ob_e3',
      etapaDestinoSenaoId: 'ob_e8',
    },
    {
      tipo: 'mover',
      nome: 'Canteiro liberado inicia a execução',
      etapaOrigemId: 'ob_e3',
      condicao: { campoId: 'ob_c20', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ob_e4',
    },
    {
      tipo: 'mover',
      nome: 'Execução concluída chama a vistoria',
      etapaOrigemId: 'ob_e4',
      condicao: { campoId: 'ob_c29', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ob_e5',
    },
    {
      tipo: 'mover',
      nome: 'Vistoria sem pendência libera a entrega',
      etapaOrigemId: 'ob_e5',
      condicao: { campoId: 'ob_c31', operador: 'igual', valor: 'Não' },
      etapaDestinoId: 'ob_e6',
      etapaDestinoSenaoId: 'ob_e4',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Detalhar aditivo só quando existir',
      etapaOrigemId: 'ob_e4',
      condicao: { campoId: 'ob_c25', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['ob_c26'],
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Listar pendências só quando houver',
      etapaOrigemId: 'ob_e5',
      condicao: { campoId: 'ob_c31', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['ob_c32'],
    },
  ],
  cards: [
    { id: 'ob_card1', titulo: 'Residencial Vista Verde - Torre A', etapaId: 'ob_e4', etiquetas: ['Obra Própria', 'Prazo Crítico'], valores: { ob_c1: 'Residencial Vista Verde - Torre A', ob_c2: 'Incorporadora própria', ob_c3: 'Residencial vertical', ob_c4: 'Av. das Palmeiras, 1200', ob_c5: 8400, ob_c7: 12800000, ob_c21: 58, ob_c22: 'Instalações', ob_c23: 7100000 } },
    { id: 'ob_card2', titulo: 'Galpão Logístico CD Sul', etapaId: 'ob_e4', etiquetas: ['Cliente Terceiro'], valores: { ob_c1: 'Galpão Logístico CD Sul', ob_c2: 'Transportes Andrade', ob_c3: 'Industrial', ob_c5: 4200, ob_c7: 5400000, ob_c21: 32, ob_c22: 'Estrutura' } },
    { id: 'ob_card3', titulo: 'Reforma da Loja Matriz', etapaId: 'ob_e5', etiquetas: ['Cliente Terceiro'], valores: { ob_c1: 'Reforma da Loja Matriz', ob_c2: 'Refricril', ob_c3: 'Reforma / Retrofit', ob_c7: 480000, ob_c21: 100, ob_c31: 'Sim', ob_c32: 'Ajuste no forro do estoque e retoque de pintura na fachada.' } },
    { id: 'ob_card4', titulo: 'Condomínio Alto da Serra', etapaId: 'ob_e2', valores: { ob_c1: 'Condomínio Alto da Serra', ob_c2: 'Incorporadora própria', ob_c3: 'Residencial horizontal', ob_c5: 15600, ob_c7: 21500000 } },
    { id: 'ob_card5', titulo: 'Centro Clínico Bela Vista', etapaId: 'ob_e3', valores: { ob_c1: 'Centro Clínico Bela Vista', ob_c2: 'Clínica Bela Vista', ob_c3: 'Comercial', ob_c7: 3200000, ob_c19: 'Marcelo Prado' } },
    { id: 'ob_card6', titulo: 'Ampliação da Fábrica - Etapa 2', etapaId: 'ob_e7', etiquetas: ['Prazo Crítico'], valores: { ob_c1: 'Ampliação da Fábrica - Etapa 2', ob_c2: 'Metalúrgica Souza', ob_c3: 'Industrial', ob_c7: 2750000, ob_c40: 'Falta de pagamento', ob_c43: 'Cliente com 2 medições em atraso. Retomada condicionada à quitação.' } },
    { id: 'ob_card7', titulo: 'Edifício Comercial Prime', etapaId: 'ob_e6', valores: { ob_c1: 'Edifício Comercial Prime', ob_c2: 'Prime Empreendimentos', ob_c3: 'Comercial', ob_c7: 9800000, ob_c37: 10120000 } },
  ],
  tour: [
    '🏗️ Uma obra por card, do orçamento à entrega das chaves.',
    '1️⃣ "Cadastro e Planejamento": contrato, prazo, orçamento e cronograma anexados.',
    '2️⃣ "Aprovação da Diretoria": margem na mesa antes de mobilizar equipe.',
    '3️⃣ "Mobilização": checklist de alvará, ART, CNO e canteiro — nada começa sem isso.',
    '4️⃣ "Execução": barra de avanço físico, valor medido x custo realizado e RDO anexado.',
    '5️⃣ "Vistoria": pendência encontrada volta o card para execução automaticamente.',
    '🔑 "Entrega": termo de recebimento, as built e habite-se guardados no card.',
    '⏸️ "Obra Paralisada" existe de propósito: obra parada tem que aparecer no quadro, não sumir.',
  ],
  etapasDicas: [
    { quemFaz: 'Engenharia / Orçamento', objetivo: 'Registrar a obra com prazo e orçamento reais.', conexoes: ['Ligue à "Contratação de Empreiteiro" para amarrar quem vai executar'] },
    { quemFaz: 'Diretoria', objetivo: 'Aprovar com a margem visível.', automacoes: ['Já configurado: aprovada vai para mobilização, reprovada registra o motivo'] },
    { quemFaz: 'Engenheiro / Encarregado', objetivo: 'Não deixar obra começar sem alvará, ART e canteiro pronto.' },
    { quemFaz: 'Engenheiro da Obra', objetivo: 'Manter avanço físico e custo atualizados semanalmente.', conexoes: ['Ligue à "Medição de Empreiteiro" para o financeiro da obra'] },
    { quemFaz: 'Engenheiro / Cliente', objetivo: 'Listar pendência antes de entregar — evita retrabalho na garantia.', automacoes: ['Já configurado: com pendência volta para execução'] },
    { quemFaz: 'Engenharia / Comercial', objetivo: 'Fechar com documentação completa.', conexoes: ['Ligue à "Assistência Técnica" para o período de garantia'] },
    { quemFaz: 'Engenheiro da Obra', objetivo: 'Deixar claro por que parou e quando retoma.' },
    { quemFaz: 'Comercial', objetivo: 'Guardar o motivo da recusa para revisar a proposta.' },
  ],
};

const medicaoEmpreiteiro: DefaultTemplate = {
  id: 'tpl_medicao_empreiteiro',
  name: 'Medição de Empreiteiro',
  descricao: 'Boletim de medição do subempreiteiro: conferência da engenharia, checagem de CND/FGTS/folha, glosa e retenção, nota fiscal e pagamento. Evita pagar medição sem documento em dia.',
  categoria: 'obras',
  icone: '📐',
  etiquetas: [
    { nome: 'Documento Pendente', cor: COR.vermelho },
    { nome: 'Glosa Aplicada', cor: COR.amarelo },
    { nome: 'Medição Final', cor: COR.roxo },
  ],
  etapas: [
    {
      id: 'md_e1', nome: 'Boletim de Medição',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['md_c1', 'md_c2', 'md_c6'],
      permiteMoverPara: ['md_e2'],
      campos: [
        { id: 'md_c1', nome: 'Identificação da Medição', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'md_c2', nome: 'Empreiteiro', tipo: 'texto', obrigatorio: true },
        { id: 'md_c3', nome: 'Obra / Centro de Custo', tipo: 'texto', obrigatorio: true },
        { id: 'md_c4', nome: 'Contrato de Referência', tipo: 'texto', obrigatorio: false },
        { id: 'md_c5', nome: 'Período Medido', tipo: 'texto', obrigatorio: true },
        { id: 'md_c6', nome: 'Valor Bruto da Medição', tipo: 'valor', obrigatorio: true },
        { id: 'md_c7', nome: '% Físico Acumulado', tipo: 'progresso', obrigatorio: false },
        { id: 'md_c8', nome: 'Serviços Executados', tipo: 'texto_longo', obrigatorio: true },
        { id: 'md_c9', nome: 'Planilha de Medição', tipo: 'anexo', obrigatorio: false },
        { id: 'md_c10', nome: 'É a medição final do contrato?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'md_e2', nome: 'Conferência da Engenharia',
      tempoMaximoHoras: 48,
      slaIgnorarFimDeSemana: true,
      camposVisiveisNoCard: ['md_c1', 'md_c11', 'md_c13'],
      permiteMoverPara: ['md_e3', 'md_e7'],
      permiteCriarCards: false,
      limparCamposAoRetornar: ['md_c11', 'md_c12', 'md_c13'],
      campos: [
        { id: 'md_c11', nome: 'Medição confere com o executado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'md_c12', nome: 'Divergência Encontrada', tipo: 'texto_longo', obrigatorio: false },
        { id: 'md_c13', nome: 'Valor Glosado', tipo: 'valor', obrigatorio: false },
        { id: 'md_c14', nome: 'Motivo da Glosa', tipo: 'texto_longo', obrigatorio: false },
        { id: 'md_c15', nome: 'Conferido por', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'md_e3', nome: 'Documentação Trabalhista',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['md_c1', 'md_c16', 'md_c17'],
      permiteMoverPara: ['md_e4', 'md_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'md_c16', nome: 'Documentos Entregues', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['CND Federal', 'CRF / FGTS', 'CNDT Trabalhista', 'Folha de pagamento do período', 'Guia FGTS quitada', 'Guia INSS / DARF', 'ASO dos funcionários', 'Ficha de EPI', 'Comprovante de vale-transporte'] },
        { id: 'md_c17', nome: 'Documentação em dia?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'md_c18', nome: 'Pendência Documental', tipo: 'texto_longo', obrigatorio: false },
        { id: 'md_c19', nome: 'Certidões e Guias', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'md_e4', nome: 'Aprovação Financeira',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['md_c1', 'md_c22', 'md_c20'],
      permiteMoverPara: ['md_e5', 'md_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'md_c20', nome: 'Retenção Contratual', tipo: 'valor', obrigatorio: false },
        { id: 'md_c21', nome: 'Outros Descontos', tipo: 'valor', obrigatorio: false },
        { id: 'md_c22', nome: 'Valor Líquido a Pagar', tipo: 'valor', obrigatorio: true },
        { id: 'md_c23', nome: 'Aprovado para pagamento?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'md_c24', nome: 'Observação Financeira', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'md_e5', nome: 'Nota Fiscal',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['md_c1', 'md_c25', 'md_c27'],
      permiteMoverPara: ['md_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'md_c25', nome: 'Nº da Nota Fiscal', tipo: 'texto', obrigatorio: true },
        { id: 'md_c26', nome: 'Arquivo da NF', tipo: 'anexo', obrigatorio: false },
        { id: 'md_c27', nome: 'Vencimento', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'md_c28', nome: 'NF conferida?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'md_e6', nome: 'Pago',
      camposVisiveisNoCard: ['md_c1', 'md_c22', 'md_c29'],
      permiteCriarCards: false,
      campos: [
        { id: 'md_c29', nome: 'Data do Pagamento', tipo: 'data', obrigatorio: false },
        { id: 'md_c30', nome: 'Comprovante', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'md_e7', nome: 'Devolvida ao Empreiteiro',
      camposVisiveisNoCard: ['md_c1', 'md_c31'],
      permiteMoverPara: ['md_e1', 'md_e2'],
      permiteCriarCards: false,
      campos: [
        { id: 'md_c31', nome: 'Motivo da Devolução', tipo: 'lista', obrigatorio: true, opcoes: ['Medição divergente', 'Documentação trabalhista', 'Serviço com defeito', 'Nota fiscal incorreta', 'Sem aprovação financeira'], coresOpcoes: { 'Documentação trabalhista': COR.vermelho, 'Serviço com defeito': COR.vermelho } },
        { id: 'md_c32', nome: 'O que precisa ser corrigido', tipo: 'texto_longo', obrigatorio: true },
        { id: 'md_c33', nome: 'Prazo para Reapresentar', tipo: 'data_vencimento', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Medição conferida vai para documentação',
      etapaOrigemId: 'md_e2',
      condicao: { campoId: 'md_c11', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'md_e3',
      etapaDestinoSenaoId: 'md_e7',
    },
    {
      tipo: 'mover',
      nome: 'Documentação em dia libera o financeiro',
      etapaOrigemId: 'md_e3',
      condicao: { campoId: 'md_c17', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'md_e4',
      etapaDestinoSenaoId: 'md_e7',
    },
    {
      tipo: 'mover',
      nome: 'Aprovada solicita a nota fiscal',
      etapaOrigemId: 'md_e4',
      condicao: { campoId: 'md_c23', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'md_e5',
      etapaDestinoSenaoId: 'md_e7',
    },
    {
      tipo: 'mover',
      nome: 'NF conferida segue para pagamento',
      etapaOrigemId: 'md_e5',
      condicao: { campoId: 'md_c28', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'md_e6',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar divergência quando não conferir',
      etapaOrigemId: 'md_e2',
      condicao: { campoId: 'md_c11', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['md_c12', 'md_c13', 'md_c14'],
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar pendência documental quando faltar documento',
      etapaOrigemId: 'md_e3',
      condicao: { campoId: 'md_c17', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['md_c18'],
    },
  ],
  cards: [
    { id: 'md_card1', titulo: 'Medição 04 - Estrutura Torre A', etapaId: 'md_e3', etiquetas: ['Documento Pendente'], valores: { md_c1: 'Medição 04 - Estrutura Torre A', md_c2: 'Construtora Pilar', md_c3: 'Vista Verde - Torre A', md_c5: '01/07 a 31/07', md_c6: 385000, md_c7: 58, md_c17: 'Não', md_c18: 'Falta CRF do FGTS e folha de julho.' } },
    { id: 'md_card2', titulo: 'Medição 09 - Instalações Elétricas', etapaId: 'md_e4', valores: { md_c1: 'Medição 09 - Instalações Elétricas', md_c2: 'ElétricaSul Serviços', md_c3: 'CD Sul', md_c5: '01/07 a 31/07', md_c6: 148000, md_c20: 7400, md_c22: 140600 } },
    { id: 'md_card3', titulo: 'Medição 02 - Alvenaria Bloco B', etapaId: 'md_e2', etiquetas: ['Glosa Aplicada'], valores: { md_c1: 'Medição 02 - Alvenaria Bloco B', md_c2: 'Empreiteira Nova Era', md_c3: 'Alto da Serra', md_c5: '01/07 a 31/07', md_c6: 96000, md_c11: 'Não', md_c13: 12000, md_c14: 'Duas paredes do 3º pavimento não executadas no período.' } },
    { id: 'md_card4', titulo: 'Medição 12 - Pintura Geral', etapaId: 'md_e5', valores: { md_c1: 'Medição 12 - Pintura Geral', md_c2: 'Pinturas Aliança', md_c3: 'Edifício Prime', md_c5: '01/07 a 31/07', md_c6: 62000, md_c22: 58900, md_c25: '4471' } },
    { id: 'md_card5', titulo: 'Medição Final - Fundação', etapaId: 'md_e6', etiquetas: ['Medição Final'], valores: { md_c1: 'Medição Final - Fundação', md_c2: 'Fundações Terra Firme', md_c3: 'Vista Verde - Torre A', md_c5: '01/06 a 30/06', md_c6: 410000, md_c10: 'Sim', md_c22: 389500 } },
    { id: 'md_card6', titulo: 'Medição 03 - Hidráulica', etapaId: 'md_e7', valores: { md_c1: 'Medição 03 - Hidráulica', md_c2: 'HidroTec', md_c3: 'Centro Clínico', md_c5: '01/07 a 31/07', md_c6: 74000, md_c31: 'Nota fiscal incorreta', md_c32: 'NF emitida com CNPJ da filial errada. Reemitir pela matriz.' } },
  ],
  tour: [
    '📐 Medição de empreiteiro sem furo: engenharia confere, DP checa documento, financeiro paga.',
    '1️⃣ "Boletim": período, serviços, valor bruto e planilha anexada.',
    '2️⃣ "Conferência da Engenharia": divergiu? o card volta pro empreiteiro com a glosa registrada.',
    '3️⃣ "Documentação Trabalhista": CND, FGTS, folha e ASO. Faltou documento, não passa.',
    '4️⃣ "Aprovação Financeira": retenção contratual e valor líquido calculados no card.',
    '5️⃣ "Nota Fiscal": vencimento vira data de cobrança do card.',
    '💸 "Pago": comprovante anexado fecha o ciclo — e fica de prova para a próxima medição.',
    '↩️ "Devolvida": tudo que volta registra motivo e prazo para reapresentar.',
  ],
  etapasDicas: [
    { quemFaz: 'Empreiteiro / Apontador', objetivo: 'Apresentar o que foi executado no período com planilha.' },
    { quemFaz: 'Engenheiro da Obra', objetivo: 'Comparar o medido com o executado em campo antes de qualquer pagamento.', automacoes: ['Já configurado: divergência devolve o boletim'] },
    { quemFaz: 'DP / Administrativo da Obra', objetivo: 'Blindar a empresa de responsabilidade solidária trabalhista.', automacoes: ['Já configurado: documento faltando devolve o boletim'] },
    { quemFaz: 'Financeiro', objetivo: 'Aplicar retenção contratual e liberar o líquido correto.' },
    { quemFaz: 'Financeiro / Fiscal', objetivo: 'Conferir a NF antes de agendar.', conexoes: ['Ligue ao fluxo de Contas a Pagar para o agendamento'] },
    { quemFaz: 'Financeiro', objetivo: 'Guardar comprovante junto da medição.' },
    { quemFaz: 'Engenharia / Financeiro', objetivo: 'Deixar claro o que o empreiteiro precisa corrigir e até quando.' },
  ],
};

const contratacaoEmpreiteiro: DefaultTemplate = {
  id: 'tpl_contratacao_empreiteiro',
  name: 'Contratação de Empreiteiro',
  descricao: 'Da definição do escopo à mobilização: cotação com três propostas, análise técnica, habilitação documental (CND, CNO, ART, seguro, NRs) e contrato assinado. Homologação de subempreiteiro sem surpresa.',
  categoria: 'obras',
  icone: '👷',
  etiquetas: [
    { nome: 'Serviço Crítico', cor: COR.vermelho },
    { nome: 'Fornecedor Novo', cor: COR.amarelo },
    { nome: 'Recorrente', cor: COR.verde },
  ],
  etapas: [
    {
      id: 'ce_e1', nome: 'Escopo do Serviço',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['ce_c1', 'ce_c2', 'ce_c5'],
      permiteMoverPara: ['ce_e2'],
      campos: [
        { id: 'ce_c1', nome: 'Serviço a Contratar', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'ce_c2', nome: 'Obra / Centro de Custo', tipo: 'texto', obrigatorio: true },
        { id: 'ce_c3', nome: 'Especialidade', tipo: 'lista', obrigatorio: true, opcoes: ['Fundação', 'Estrutura / Concreto', 'Alvenaria', 'Elétrica', 'Hidráulica', 'Climatização', 'Impermeabilização', 'Esquadrias', 'Pintura', 'Gesso / Forro', 'Terraplenagem', 'Paisagismo'] },
        { id: 'ce_c4', nome: 'Escopo Detalhado', tipo: 'texto_longo', obrigatorio: true },
        { id: 'ce_c5', nome: 'Valor Estimado', tipo: 'valor', obrigatorio: false },
        { id: 'ce_c6', nome: 'Prazo de Execução', tipo: 'texto', obrigatorio: false },
        { id: 'ce_c7', nome: 'Data Necessária em Obra', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'ce_c8', nome: 'Projeto / Memorial', tipo: 'anexo', obrigatorio: false },
        { id: 'ce_c9', nome: 'Criticidade', tipo: 'lista', obrigatorio: false, opcoes: ['Baixa', 'Média', 'Alta', 'Urgente'], coresOpcoes: CORES_PRIORIDADE },
      ],
    },
    {
      id: 'ce_e2', nome: 'Cotação',
      tempoMaximoHoras: 96,
      camposVisiveisNoCard: ['ce_c1', 'ce_c10', 'ce_c16'],
      permiteMoverPara: ['ce_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'ce_c10', nome: 'Empreiteiro 1', tipo: 'texto', obrigatorio: true },
        { id: 'ce_c11', nome: 'Valor 1', tipo: 'valor', obrigatorio: true },
        { id: 'ce_c12', nome: 'Empreiteiro 2', tipo: 'texto', obrigatorio: false },
        { id: 'ce_c13', nome: 'Valor 2', tipo: 'valor', obrigatorio: false },
        { id: 'ce_c14', nome: 'Empreiteiro 3', tipo: 'texto', obrigatorio: false },
        { id: 'ce_c15', nome: 'Valor 3', tipo: 'valor', obrigatorio: false },
        { id: 'ce_c16', nome: 'Propostas Recebidas', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'ce_e3', nome: 'Análise Técnica',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['ce_c1', 'ce_c17', 'ce_c18'],
      permiteMoverPara: ['ce_e4', 'ce_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'ce_c17', nome: 'Empreiteiro Escolhido', tipo: 'texto', obrigatorio: true },
        { id: 'ce_c18', nome: 'Valor Negociado', tipo: 'valor', obrigatorio: true },
        { id: 'ce_c19', nome: 'Justificativa da Escolha', tipo: 'texto_longo', obrigatorio: true },
        { id: 'ce_c20', nome: 'Já trabalhou conosco?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ce_c21', nome: 'Referências Consultadas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'ce_c22', nome: 'Aprovado tecnicamente?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'ce_e4', nome: 'Habilitação Documental',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['ce_c1', 'ce_c17', 'ce_c24'],
      permiteMoverPara: ['ce_e5', 'ce_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'ce_c23', nome: 'Documentos Recebidos', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Cartão CNPJ', 'Contrato social', 'CND Federal', 'CRF / FGTS', 'CNDT Trabalhista', 'Certidão municipal', 'ART / RRT do responsável', 'Registro no CREA/CAU', 'Apólice de seguro', 'Treinamentos de NR', 'Relação de funcionários'] },
        { id: 'ce_c24', nome: 'Habilitado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ce_c25', nome: 'Pendências Documentais', tipo: 'texto_longo', obrigatorio: false },
        { id: 'ce_c26', nome: 'Pasta de Documentos', tipo: 'anexo', obrigatorio: false },
        { id: 'ce_c27', nome: 'Validade das Certidões', tipo: 'data_vencimento', obrigatorio: false },
      ],
    },
    {
      id: 'ce_e5', nome: 'Contrato',
      tempoMaximoHoras: 96,
      camposVisiveisNoCard: ['ce_c1', 'ce_c18', 'ce_c31'],
      permiteMoverPara: ['ce_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'ce_c28', nome: 'Forma de Pagamento', tipo: 'lista', obrigatorio: false, opcoes: ['Por medição mensal', 'Por etapa concluída', 'Parcelado fixo', 'À vista na entrega'] },
        { id: 'ce_c29', nome: '% de Retenção', tipo: 'numero', obrigatorio: false },
        { id: 'ce_c30', nome: 'Multa por Atraso', tipo: 'texto', obrigatorio: false },
        { id: 'ce_c31', nome: 'Contrato assinado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ce_c32', nome: 'Contrato Assinado (PDF)', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'ce_e6', nome: 'Contratado / Mobilizado',
      camposVisiveisNoCard: ['ce_c1', 'ce_c17', 'ce_c33'],
      permiteCriarCards: false,
      campos: [
        { id: 'ce_c33', nome: 'Data de Início em Obra', tipo: 'data', obrigatorio: false },
        { id: 'ce_c34', nome: 'Integração de Segurança Realizada', tipo: 'checkbox_single', obrigatorio: false, opcoes: ['Realizada'] },
        { id: 'ce_c35', nome: 'Observações', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'ce_e7', nome: 'Não Contratado',
      camposVisiveisNoCard: ['ce_c1', 'ce_c36'],
      permiteMoverPara: ['ce_e2'],
      permiteCriarCards: false,
      campos: [
        { id: 'ce_c36', nome: 'Motivo', tipo: 'lista', obrigatorio: true, opcoes: ['Preço acima do orçado', 'Reprovado tecnicamente', 'Documentação irregular', 'Sem disponibilidade de prazo', 'Serviço cancelado'], coresOpcoes: { 'Documentação irregular': COR.vermelho, 'Reprovado tecnicamente': COR.vermelho } },
        { id: 'ce_c37', nome: 'Detalhamento', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Aprovado tecnicamente vai para habilitação',
      etapaOrigemId: 'ce_e3',
      condicao: { campoId: 'ce_c22', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ce_e4',
      etapaDestinoSenaoId: 'ce_e7',
    },
    {
      tipo: 'mover',
      nome: 'Habilitado segue para contrato',
      etapaOrigemId: 'ce_e4',
      condicao: { campoId: 'ce_c24', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ce_e5',
      etapaDestinoSenaoId: 'ce_e7',
    },
    {
      tipo: 'mover',
      nome: 'Contrato assinado libera a mobilização',
      etapaOrigemId: 'ce_e5',
      condicao: { campoId: 'ce_c31', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ce_e6',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar pendências quando não habilitar',
      etapaOrigemId: 'ce_e4',
      condicao: { campoId: 'ce_c24', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['ce_c25'],
    },
  ],
  cards: [
    { id: 'ce_card1', titulo: 'Impermeabilização das lajes - Torre A', etapaId: 'ce_e4', etiquetas: ['Serviço Crítico', 'Fornecedor Novo'], valores: { ce_c1: 'Impermeabilização das lajes - Torre A', ce_c2: 'Vista Verde - Torre A', ce_c3: 'Impermeabilização', ce_c5: 210000, ce_c17: 'Impermax Engenharia', ce_c18: 196000, ce_c24: 'Não', ce_c25: 'CNDT vencida e falta ART do responsável técnico.' } },
    { id: 'ce_card2', titulo: 'Instalações elétricas do galpão', etapaId: 'ce_e5', valores: { ce_c1: 'Instalações elétricas do galpão', ce_c2: 'CD Sul', ce_c3: 'Elétrica', ce_c5: 340000, ce_c17: 'ElétricaSul Serviços', ce_c18: 318000, ce_c28: 'Por medição mensal', ce_c29: 5 } },
    { id: 'ce_card3', titulo: 'Terraplenagem do lote 12', etapaId: 'ce_e2', valores: { ce_c1: 'Terraplenagem do lote 12', ce_c2: 'Alto da Serra', ce_c3: 'Terraplenagem', ce_c5: 180000, ce_c10: 'Terra Sul Máquinas', ce_c11: 174000, ce_c12: 'Movtec', ce_c13: 189000 } },
    { id: 'ce_card4', titulo: 'Gesso e forro do centro clínico', etapaId: 'ce_e6', etiquetas: ['Recorrente'], valores: { ce_c1: 'Gesso e forro do centro clínico', ce_c2: 'Centro Clínico', ce_c3: 'Gesso / Forro', ce_c17: 'Gesso Prime', ce_c18: 88000, ce_c20: 'Sim' } },
    { id: 'ce_card5', titulo: 'Esquadrias de alumínio - fachada', etapaId: 'ce_e3', etiquetas: ['Serviço Crítico'], valores: { ce_c1: 'Esquadrias de alumínio - fachada', ce_c2: 'Edifício Prime', ce_c3: 'Esquadrias', ce_c5: 620000, ce_c10: 'Alumifort', ce_c11: 598000 } },
    { id: 'ce_card6', titulo: 'Paisagismo da área comum', etapaId: 'ce_e7', valores: { ce_c1: 'Paisagismo da área comum', ce_c2: 'Alto da Serra', ce_c3: 'Paisagismo', ce_c36: 'Preço acima do orçado', ce_c37: 'Todas as propostas 40% acima do orçamento. Reabrir cotação na fase de acabamento.' } },
  ],
  tour: [
    '👷 Empreiteiro só entra em obra com técnica aprovada, documento em dia e contrato assinado.',
    '1️⃣ "Escopo": o que exatamente vai ser contratado, com projeto anexado.',
    '2️⃣ "Cotação": três propostas lado a lado no mesmo card.',
    '3️⃣ "Análise Técnica": escolha justificada — preço não decide sozinho.',
    '4️⃣ "Habilitação": checklist de CND, CNO, ART, seguro e NR. Faltou, não contrata.',
    '5️⃣ "Contrato": forma de pagamento, retenção e multa registradas antes de assinar.',
    '🔨 "Contratado": integração de segurança feita e data de início em obra.',
  ],
  etapasDicas: [
    { quemFaz: 'Engenharia', objetivo: 'Definir escopo claro — escopo vago vira aditivo depois.' },
    { quemFaz: 'Suprimentos', objetivo: 'Trazer no mínimo três propostas comparáveis.' },
    { quemFaz: 'Engenheiro / Gerente de Obra', objetivo: 'Escolher por técnica e histórico, não só por preço.', automacoes: ['Já configurado: reprovado vai para "Não Contratado"'] },
    { quemFaz: 'Administrativo / Jurídico', objetivo: 'Blindar a empresa de passivo trabalhista e previdenciário.', automacoes: ['Já configurado: não habilitado não avança'] },
    { quemFaz: 'Jurídico / Diretoria', objetivo: 'Amarrar retenção e multa antes da assinatura.', conexoes: ['Ligue ao fluxo de Contratos para a gestão do vencimento'] },
    { quemFaz: 'Engenheiro da Obra', objetivo: 'Só liberar acesso ao canteiro após integração de segurança.', conexoes: ['Ligue à "Medição de Empreiteiro" para o pagamento mensal'] },
    { quemFaz: 'Suprimentos', objetivo: 'Registrar por que não fechou — serve de histórico do fornecedor.' },
  ],
};

const suprimentosObra: DefaultTemplate = {
  id: 'tpl_suprimentos_obra',
  name: 'Requisição de Material de Obra',
  descricao: 'Pedido do canteiro até a entrega conferida: checagem de estoque e transferência entre obras, cotação, alçada de aprovação e recebimento com divergência. Material certo, na obra certa, no dia certo.',
  categoria: 'obras',
  icone: '🧱',
  etiquetas: [
    { nome: 'Obra Parada', cor: COR.vermelho },
    { nome: 'Urgente', cor: COR.amarelo },
    { nome: 'Programado', cor: COR.verde },
  ],
  etapas: [
    {
      id: 'sp_e1', nome: 'Requisição do Canteiro',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['sp_c1', 'sp_c2', 'sp_c7'],
      permiteMoverPara: ['sp_e2'],
      campos: [
        { id: 'sp_c1', nome: 'Material Solicitado', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'sp_c2', nome: 'Obra / Centro de Custo', tipo: 'texto', obrigatorio: true },
        { id: 'sp_c3', nome: 'Solicitante', tipo: 'texto', obrigatorio: true },
        { id: 'sp_c4', nome: 'Categoria', tipo: 'lista', obrigatorio: true, opcoes: ['Cimento e agregados', 'Aço e ferragem', 'Blocos e alvenaria', 'Elétrica', 'Hidráulica', 'Revestimento', 'Tintas', 'Madeira e formas', 'Ferramentas', 'EPI', 'Locação de equipamento'] },
        { id: 'sp_c5', nome: 'Quantidade', tipo: 'numero', obrigatorio: true },
        { id: 'sp_c6', nome: 'Unidade', tipo: 'lista', obrigatorio: false, opcoes: ['un', 'm', 'm²', 'm³', 'kg', 'ton', 'saco', 'litro', 'peça', 'diária'] },
        { id: 'sp_c7', nome: 'Data Necessária em Obra', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'sp_c8', nome: 'Aplicação / Justificativa', tipo: 'texto_longo', obrigatorio: false },
        { id: 'sp_c9', nome: 'Urgência', tipo: 'lista', obrigatorio: false, opcoes: ['Baixa', 'Média', 'Alta', 'Urgente'], coresOpcoes: CORES_PRIORIDADE },
      ],
    },
    {
      id: 'sp_e2', nome: 'Análise de Estoque',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['sp_c1', 'sp_c10'],
      permiteMoverPara: ['sp_e3', 'sp_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'sp_c10', nome: 'Tem em estoque ou em outra obra?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'sp_c11', nome: 'Origem da Transferência', tipo: 'texto', obrigatorio: false },
        { id: 'sp_c12', nome: 'Quantidade Disponível', tipo: 'numero', obrigatorio: false },
        { id: 'sp_c13', nome: 'Observação do Almoxarifado', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'sp_e3', nome: 'Cotação',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['sp_c1', 'sp_c14', 'sp_c18'],
      permiteMoverPara: ['sp_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'sp_c14', nome: 'Fornecedor 1', tipo: 'texto', obrigatorio: true },
        { id: 'sp_c15', nome: 'Valor 1', tipo: 'valor', obrigatorio: true },
        { id: 'sp_c16', nome: 'Fornecedor 2', tipo: 'texto', obrigatorio: false },
        { id: 'sp_c17', nome: 'Valor 2', tipo: 'valor', obrigatorio: false },
        { id: 'sp_c18', nome: 'Melhor Proposta', tipo: 'valor', obrigatorio: false },
        { id: 'sp_c19', nome: 'Prazo de Entrega do Fornecedor', tipo: 'texto', obrigatorio: false },
        { id: 'sp_c20', nome: 'Cotações', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'sp_e4', nome: 'Aprovação',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['sp_c1', 'sp_c18', 'sp_c21'],
      permiteMoverPara: ['sp_e5', 'sp_e7'],
      permiteCriarCards: false,
      limparCamposAoRetornar: ['sp_c21', 'sp_c22'],
      campos: [
        { id: 'sp_c21', nome: 'Aprovado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'sp_c22', nome: 'Observação da Aprovação', tipo: 'texto_longo', obrigatorio: false },
        { id: 'sp_c23', nome: 'Aprovador', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'sp_e5', nome: 'Compra e Entrega',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['sp_c1', 'sp_c24', 'sp_c26'],
      permiteMoverPara: ['sp_e6'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'sp_c24', nome: 'Fornecedor Escolhido', tipo: 'texto', obrigatorio: false },
        { id: 'sp_c25', nome: 'Nº do Pedido', tipo: 'texto', obrigatorio: false },
        { id: 'sp_c26', nome: 'Previsão de Entrega', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'sp_c27', nome: 'Nota Fiscal', tipo: 'anexo', obrigatorio: false },
        { id: 'sp_c28', nome: 'Material entregue?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'sp_e6', nome: 'Recebido no Canteiro',
      camposVisiveisNoCard: ['sp_c1', 'sp_c29', 'sp_c30'],
      permiteCriarCards: false,
      campos: [
        { id: 'sp_c29', nome: 'Data do Recebimento', tipo: 'data', obrigatorio: false },
        { id: 'sp_c30', nome: 'Recebido conforme?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'sp_c31', nome: 'Divergência no Recebimento', tipo: 'texto_longo', obrigatorio: false },
        { id: 'sp_c32', nome: 'Conferido por', tipo: 'texto', obrigatorio: false },
        { id: 'sp_c33', nome: 'Foto do Material', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'sp_e7', nome: 'Cancelada',
      camposVisiveisNoCard: ['sp_c1', 'sp_c34'],
      permiteMoverPara: ['sp_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'sp_c34', nome: 'Motivo do Cancelamento', tipo: 'texto_longo', obrigatorio: true },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Sem estoque vai para cotação',
      etapaOrigemId: 'sp_e2',
      condicao: { campoId: 'sp_c10', operador: 'igual', valor: 'Não' },
      etapaDestinoId: 'sp_e3',
      etapaDestinoSenaoId: 'sp_e6',
    },
    {
      tipo: 'mover',
      nome: 'Aprovado vira compra',
      etapaOrigemId: 'sp_e4',
      condicao: { campoId: 'sp_c21', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'sp_e5',
      etapaDestinoSenaoId: 'sp_e7',
    },
    {
      tipo: 'mover',
      nome: 'Entrega confirmada fecha no canteiro',
      etapaOrigemId: 'sp_e5',
      condicao: { campoId: 'sp_c28', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'sp_e6',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar origem quando houver transferência',
      etapaOrigemId: 'sp_e2',
      condicao: { campoId: 'sp_c10', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['sp_c11', 'sp_c12'],
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Registrar divergência quando não conferir',
      etapaOrigemId: 'sp_e6',
      condicao: { campoId: 'sp_c30', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['sp_c31'],
    },
  ],
  cards: [
    { id: 'sp_card1', titulo: 'Aço CA-50 12mm - 4 ton', etapaId: 'sp_e4', etiquetas: ['Obra Parada'], valores: { sp_c1: 'Aço CA-50 12mm - 4 ton', sp_c2: 'Vista Verde - Torre A', sp_c3: 'Marcelo Prado', sp_c4: 'Aço e ferragem', sp_c5: 4, sp_c6: 'ton', sp_c9: 'Urgente', sp_c18: 34800 } },
    { id: 'sp_card2', titulo: 'Cimento CP-II - 300 sacos', etapaId: 'sp_e5', etiquetas: ['Programado'], valores: { sp_c1: 'Cimento CP-II - 300 sacos', sp_c2: 'Alto da Serra', sp_c3: 'Almoxarifado', sp_c4: 'Cimento e agregados', sp_c5: 300, sp_c6: 'saco', sp_c24: 'Depósito Central', sp_c26: '2026-08-20' } },
    { id: 'sp_card3', titulo: 'Cabo flexível 2,5mm - 500m', etapaId: 'sp_e3', valores: { sp_c1: 'Cabo flexível 2,5mm - 500m', sp_c2: 'CD Sul', sp_c3: 'ElétricaSul', sp_c4: 'Elétrica', sp_c5: 500, sp_c6: 'm', sp_c14: 'Elétrica Total', sp_c15: 4200 } },
    { id: 'sp_card4', titulo: 'Locação de betoneira 400L', etapaId: 'sp_e2', valores: { sp_c1: 'Locação de betoneira 400L', sp_c2: 'Centro Clínico', sp_c3: 'Encarregado', sp_c4: 'Locação de equipamento', sp_c5: 1, sp_c6: 'diária', sp_c10: 'Sim', sp_c11: 'Canteiro Vista Verde (ociosa)' } },
    { id: 'sp_card5', titulo: 'Capacetes e luvas - reposição', etapaId: 'sp_e6', valores: { sp_c1: 'Capacetes e luvas - reposição', sp_c2: 'Vista Verde - Torre A', sp_c3: 'Técnico de Segurança', sp_c4: 'EPI', sp_c5: 40, sp_c6: 'un', sp_c30: 'Sim' } },
    { id: 'sp_card6', titulo: 'Porcelanato 60x60 - área comum', etapaId: 'sp_e1', valores: { sp_c1: 'Porcelanato 60x60 - área comum', sp_c2: 'Edifício Prime', sp_c3: 'Engenharia', sp_c4: 'Revestimento', sp_c5: 620, sp_c6: 'm²' } },
    { id: 'sp_card7', titulo: 'Andaime fachadeiro - 200m²', etapaId: 'sp_e7', valores: { sp_c1: 'Andaime fachadeiro - 200m²', sp_c2: 'Alto da Serra', sp_c3: 'Encarregado', sp_c4: 'Locação de equipamento', sp_c5: 200, sp_c34: 'Serviço de fachada adiado para a próxima etapa da obra.' } },
  ],
  tour: [
    '🧱 Material de obra com rastro: quem pediu, para qual obra, quem aprovou e quem recebeu.',
    '1️⃣ "Requisição": obra, quantidade e a data em que precisa estar no canteiro.',
    '2️⃣ "Análise de Estoque": tem em outra obra? transfere e economiza a compra.',
    '3️⃣ "Cotação": fornecedores comparados no card.',
    '4️⃣ "Aprovação": alçada decide com o valor na frente.',
    '5️⃣ "Compra e Entrega": os cards se ordenam pela data de entrega mais próxima.',
    '📥 "Recebido": conferência com foto e registro de divergência.',
  ],
  etapasDicas: [
    { quemFaz: 'Encarregado / Engenheiro', objetivo: 'Pedir com antecedência — data necessária é o que vira cobrança.' },
    { quemFaz: 'Almoxarifado', objetivo: 'Olhar as outras obras antes de comprar.', automacoes: ['Já configurado: com estoque vai direto para o canteiro'] },
    { quemFaz: 'Suprimentos', objetivo: 'Cotar com prazo de entrega, não só preço.' },
    { quemFaz: 'Gerente de Obra / Diretoria', objetivo: 'Aprovar pelo valor e pelo impacto no cronograma.' },
    { quemFaz: 'Suprimentos', objetivo: 'Acompanhar a entrega até o canteiro.', conexoes: ['Ligue ao fluxo de Contas a Pagar pela nota fiscal'] },
    { quemFaz: 'Almoxarife do Canteiro', objetivo: 'Conferir na chegada — divergência descoberta depois vira prejuízo.' },
    { quemFaz: 'Suprimentos', objetivo: 'Registrar o motivo do cancelamento.' },
  ],
};

const segurancaObra: DefaultTemplate = {
  id: 'tpl_seguranca_obra',
  name: 'Segurança do Trabalho na Obra',
  descricao: 'Inspeções, quase-acidentes e acidentes em um só quadro: classificação de risco, ação corretiva com prazo, verificação de eficácia e emissão de CAT quando houver afastamento. NR-18 na prática.',
  categoria: 'obras',
  icone: '🦺',
  etiquetas: [
    { nome: 'Acidente', cor: COR.vermelho },
    { nome: 'Risco Alto', cor: COR.amarelo },
    { nome: 'Inspeção de Rotina', cor: COR.azul },
  ],
  etapas: [
    {
      id: 'sg_e1', nome: 'Registro da Ocorrência',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['sg_c1', 'sg_c2', 'sg_c4'],
      permiteMoverPara: ['sg_e2'],
      campos: [
        { id: 'sg_c1', nome: 'Ocorrência', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'sg_c2', nome: 'Tipo', tipo: 'lista', obrigatorio: true, opcoes: ['Inspeção de rotina', 'Condição insegura', 'Ato inseguro', 'Quase-acidente', 'Acidente sem afastamento', 'Acidente com afastamento', 'DDS registrado'], coresOpcoes: { 'Acidente com afastamento': COR.vermelho, 'Acidente sem afastamento': COR.amarelo, 'Quase-acidente': COR.amarelo, 'Inspeção de rotina': COR.azul } },
        { id: 'sg_c3', nome: 'Obra / Local', tipo: 'texto', obrigatorio: true },
        { id: 'sg_c4', nome: 'Data e Hora', tipo: 'data', obrigatorio: true },
        { id: 'sg_c5', nome: 'Envolvidos', tipo: 'texto', obrigatorio: false },
        { id: 'sg_c6', nome: 'Empresa do Envolvido', tipo: 'lista', obrigatorio: false, opcoes: ['Própria', 'Empreiteiro', 'Fornecedor', 'Visitante'] },
        { id: 'sg_c7', nome: 'Descrição do Fato', tipo: 'texto_longo', obrigatorio: true },
        { id: 'sg_c8', nome: 'Fotos / Evidências', tipo: 'anexo', obrigatorio: false },
        { id: 'sg_c9', nome: 'Norma Relacionada', tipo: 'lista', obrigatorio: false, opcoes: ['NR-06 EPI', 'NR-10 Elétrica', 'NR-12 Máquinas', 'NR-18 Construção', 'NR-33 Espaço confinado', 'NR-35 Altura', 'Outra'] },
      ],
    },
    {
      id: 'sg_e2', nome: 'Análise de Risco',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['sg_c1', 'sg_c10', 'sg_c13'],
      permiteMoverPara: ['sg_e3', 'sg_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'sg_c10', nome: 'Grau de Risco', tipo: 'lista', obrigatorio: true, opcoes: ['Baixo', 'Médio', 'Alto', 'Crítico'], coresOpcoes: { 'Baixo': COR.cinza, 'Médio': COR.azul, 'Alto': COR.amarelo, 'Crítico': COR.vermelho } },
        { id: 'sg_c11', nome: 'Causa Raiz', tipo: 'texto_longo', obrigatorio: true },
        { id: 'sg_c12', nome: 'Houve afastamento?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'sg_c13', nome: 'Precisa de ação corretiva?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'sg_c14', nome: 'CAT emitida?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'sg_c15', nome: 'CAT / ASO', tipo: 'anexo', obrigatorio: false },
        { id: 'sg_c16', nome: 'Dias de Afastamento', tipo: 'numero', obrigatorio: false },
      ],
    },
    {
      id: 'sg_e3', nome: 'Ação Corretiva',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['sg_c1', 'sg_c18', 'sg_c19'],
      permiteMoverPara: ['sg_e4'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'sg_c17', nome: 'Ação Definida', tipo: 'texto_longo', obrigatorio: true },
        { id: 'sg_c18', nome: 'Responsável pela Ação', tipo: 'texto', obrigatorio: true },
        { id: 'sg_c19', nome: 'Prazo', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'sg_c20', nome: 'Tipo de Ação', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Treinamento', 'Substituição de EPI', 'Isolamento da área', 'Manutenção de equipamento', 'Alteração de procedimento', 'Advertência', 'Sinalização'] },
        { id: 'sg_c21', nome: 'Ação concluída?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'sg_c22', nome: 'Evidência da Ação', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'sg_e4', nome: 'Verificação de Eficácia',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['sg_c1', 'sg_c23'],
      permiteMoverPara: ['sg_e5', 'sg_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'sg_c23', nome: 'Ação foi eficaz?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'sg_c24', nome: 'Verificado por', tipo: 'texto', obrigatorio: false },
        { id: 'sg_c25', nome: 'Observação da Verificação', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'sg_e5', nome: 'Encerrado',
      camposVisiveisNoCard: ['sg_c1', 'sg_c2', 'sg_c26'],
      permiteCriarCards: false,
      campos: [
        { id: 'sg_c26', nome: 'Data de Encerramento', tipo: 'data', obrigatorio: false },
        { id: 'sg_c27', nome: 'Lição Aprendida', tipo: 'texto_longo', obrigatorio: false },
        { id: 'sg_c28', nome: 'Divulgado no DDS?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Com ação corretiva vai para tratamento',
      etapaOrigemId: 'sg_e2',
      condicao: { campoId: 'sg_c13', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'sg_e3',
      etapaDestinoSenaoId: 'sg_e5',
    },
    {
      tipo: 'mover',
      nome: 'Ação concluída vai para verificação',
      etapaOrigemId: 'sg_e3',
      condicao: { campoId: 'sg_c21', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'sg_e4',
    },
    {
      tipo: 'mover',
      nome: 'Ação eficaz encerra a ocorrência',
      etapaOrigemId: 'sg_e4',
      condicao: { campoId: 'sg_c23', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'sg_e5',
      etapaDestinoSenaoId: 'sg_e3',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Campos de CAT só com afastamento',
      etapaOrigemId: 'sg_e2',
      condicao: { campoId: 'sg_c12', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['sg_c14', 'sg_c15', 'sg_c16'],
    },
  ],
  cards: [
    { id: 'sg_card1', titulo: 'Trabalho em altura sem cinto - 5º pav.', etapaId: 'sg_e3', etiquetas: ['Risco Alto'], valores: { sg_c1: 'Trabalho em altura sem cinto - 5º pav.', sg_c2: 'Ato inseguro', sg_c3: 'Vista Verde - Torre A', sg_c6: 'Empreiteiro', sg_c9: 'NR-35 Altura', sg_c10: 'Crítico', sg_c13: 'Sim', sg_c18: 'Técnico de Segurança', sg_c19: '2026-08-18' } },
    { id: 'sg_card2', titulo: 'Corte na mão com serra circular', etapaId: 'sg_e2', etiquetas: ['Acidente'], valores: { sg_c1: 'Corte na mão com serra circular', sg_c2: 'Acidente sem afastamento', sg_c3: 'CD Sul', sg_c6: 'Própria', sg_c9: 'NR-12 Máquinas', sg_c10: 'Alto', sg_c12: 'Não' } },
    { id: 'sg_card3', titulo: 'Inspeção mensal de andaimes', etapaId: 'sg_e5', etiquetas: ['Inspeção de Rotina'], valores: { sg_c1: 'Inspeção mensal de andaimes', sg_c2: 'Inspeção de rotina', sg_c3: 'Alto da Serra', sg_c9: 'NR-18 Construção', sg_c10: 'Baixo', sg_c13: 'Não' } },
    { id: 'sg_card4', titulo: 'Queda de material da laje', etapaId: 'sg_e4', etiquetas: ['Risco Alto'], valores: { sg_c1: 'Queda de material da laje', sg_c2: 'Quase-acidente', sg_c3: 'Edifício Prime', sg_c10: 'Alto', sg_c13: 'Sim', sg_c21: 'Sim' } },
    { id: 'sg_card5', titulo: 'Quadro elétrico sem sinalização', etapaId: 'sg_e1', valores: { sg_c1: 'Quadro elétrico sem sinalização', sg_c2: 'Condição insegura', sg_c3: 'Centro Clínico', sg_c9: 'NR-10 Elétrica' } },
    { id: 'sg_card6', titulo: 'Torção de tornozelo na escada', etapaId: 'sg_e2', etiquetas: ['Acidente'], valores: { sg_c1: 'Torção de tornozelo na escada', sg_c2: 'Acidente com afastamento', sg_c3: 'Vista Verde - Torre A', sg_c6: 'Própria', sg_c10: 'Alto', sg_c12: 'Sim', sg_c14: 'Sim', sg_c16: 5 } },
  ],
  tour: [
    '🦺 Inspeção, quase-acidente e acidente no mesmo quadro — e nada fica sem tratamento.',
    '1️⃣ "Registro": tipo, local, envolvidos, foto e a NR relacionada.',
    '2️⃣ "Análise de Risco": causa raiz e grau. Com afastamento, os campos de CAT aparecem sozinhos.',
    '3️⃣ "Ação Corretiva": responsável e prazo — os cards se ordenam pelo vencimento.',
    '4️⃣ "Verificação": não foi eficaz? volta para uma nova ação.',
    '✅ "Encerrado": lição aprendida registrada e divulgada no DDS.',
    '📊 Filtre por tipo para levantar taxa de frequência e gravidade do período.',
  ],
  etapasDicas: [
    { quemFaz: 'Técnico de Segurança / Encarregado', objetivo: 'Registrar tudo, inclusive quase-acidente — é o que evita o acidente real.' },
    { quemFaz: 'SESMT / Engenheiro de Segurança', objetivo: 'Achar a causa raiz, não o culpado.', automacoes: ['Já configurado: campos de CAT aparecem só com afastamento'] },
    { quemFaz: 'Responsável designado', objetivo: 'Executar a ação dentro do prazo.' },
    { quemFaz: 'Técnico de Segurança', objetivo: 'Confirmar que a ação resolveu de verdade.', automacoes: ['Já configurado: ineficaz volta para nova ação'] },
    { quemFaz: 'SESMT', objetivo: 'Transformar a ocorrência em treinamento para as outras obras.' },
  ],
};

const assistenciaTecnicaObra: DefaultTemplate = {
  id: 'tpl_assistencia_tecnica_obra',
  name: 'Assistência Técnica / Garantia',
  descricao: 'Chamado de garantia do cliente até o reparo aceito: triagem, vistoria com laudo de responsabilidade (construtora, fornecedor ou uso indevido), execução e termo de conclusão assinado.',
  categoria: 'obras',
  icone: '🛠️',
  etiquetas: [
    { nome: 'Infiltração', cor: COR.azul },
    { nome: 'Fora de Garantia', cor: COR.cinza },
    { nome: 'Reincidente', cor: COR.vermelho },
  ],
  etapas: [
    {
      id: 'at_e1', nome: 'Chamado do Cliente',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['at_c1', 'at_c2', 'at_c5'],
      permiteMoverPara: ['at_e2'],
      campos: [
        { id: 'at_c1', nome: 'Problema Relatado', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'at_c2', nome: 'Empreendimento / Obra', tipo: 'texto', obrigatorio: true },
        { id: 'at_c3', nome: 'Unidade / Bloco', tipo: 'texto', obrigatorio: false },
        { id: 'at_c4', nome: 'Cliente', tipo: 'texto', obrigatorio: true },
        { id: 'at_c5', nome: 'Telefone de Contato', tipo: 'telefone', obrigatorio: false },
        { id: 'at_c6', nome: 'Data da Entrega da Unidade', tipo: 'data', obrigatorio: false },
        { id: 'at_c7', nome: 'Sistema Afetado', tipo: 'lista', obrigatorio: true, opcoes: ['Impermeabilização / Infiltração', 'Hidráulica', 'Elétrica', 'Esquadrias', 'Revestimento / Piso', 'Pintura', 'Estrutura / Fissura', 'Louças e metais', 'Área comum'] },
        { id: 'at_c8', nome: 'Descrição do Cliente', tipo: 'texto_longo', obrigatorio: true },
        { id: 'at_c9', nome: 'Fotos do Cliente', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'at_e2', nome: 'Triagem e Agendamento',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['at_c1', 'at_c10', 'at_c11'],
      permiteMoverPara: ['at_e3', 'at_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'at_c10', nome: 'Dentro do prazo de garantia?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'at_c11', nome: 'Data da Vistoria', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'at_c12', nome: 'Técnico Designado', tipo: 'texto', obrigatorio: false },
        { id: 'at_c13', nome: 'Prioridade', tipo: 'lista', obrigatorio: false, opcoes: ['Baixa', 'Média', 'Alta', 'Urgente'], coresOpcoes: CORES_PRIORIDADE },
      ],
    },
    {
      id: 'at_e3', nome: 'Vistoria Técnica',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['at_c1', 'at_c14', 'at_c15'],
      permiteMoverPara: ['at_e4', 'at_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'at_c14', nome: 'Procedente?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'at_c15', nome: 'Responsabilidade', tipo: 'lista', obrigatorio: false, opcoes: ['Construtora', 'Fornecedor / Fabricante', 'Empreiteiro executor', 'Uso indevido do cliente', 'Manutenção não realizada'], coresOpcoes: { 'Construtora': COR.amarelo, 'Uso indevido do cliente': COR.cinza, 'Manutenção não realizada': COR.cinza } },
        { id: 'at_c16', nome: 'Laudo Técnico', tipo: 'texto_longo', obrigatorio: true },
        { id: 'at_c17', nome: 'Fotos da Vistoria', tipo: 'anexo', obrigatorio: false },
        { id: 'at_c18', nome: 'Custo Estimado do Reparo', tipo: 'valor', obrigatorio: false },
        { id: 'at_c19', nome: 'Problema já ocorreu antes?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'at_e4', nome: 'Execução do Reparo',
      tempoMaximoHoras: 168,
      camposVisiveisNoCard: ['at_c1', 'at_c20', 'at_c21'],
      permiteMoverPara: ['at_e5'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'at_c20', nome: 'Executante', tipo: 'texto', obrigatorio: false },
        { id: 'at_c21', nome: 'Prazo do Reparo', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'at_c22', nome: 'Serviço Executado', tipo: 'texto_longo', obrigatorio: false },
        { id: 'at_c23', nome: 'Custo Real', tipo: 'valor', obrigatorio: false },
        { id: 'at_c24', nome: 'Fotos do Reparo', tipo: 'anexo', obrigatorio: false },
        { id: 'at_c25', nome: 'Reparo concluído?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'at_e5', nome: 'Aceite do Cliente',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['at_c1', 'at_c26'],
      permiteMoverPara: ['at_e6', 'at_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'at_c26', nome: 'Cliente aprovou o reparo?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'at_c27', nome: 'Termo de Conclusão Assinado', tipo: 'anexo', obrigatorio: false },
        { id: 'at_c28', nome: 'Manifestação do Cliente', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'at_e6', nome: 'Encerrado',
      camposVisiveisNoCard: ['at_c1', 'at_c29', 'at_c30'],
      permiteCriarCards: false,
      campos: [
        { id: 'at_c29', nome: 'Desfecho', tipo: 'lista', obrigatorio: false, opcoes: ['Reparado e aceito', 'Improcedente', 'Fora de garantia', 'Encaminhado ao fornecedor', 'Cliente desistiu'], coresOpcoes: { 'Reparado e aceito': COR.verde, 'Improcedente': COR.cinza, 'Fora de garantia': COR.cinza } },
        { id: 'at_c30', nome: 'Data de Encerramento', tipo: 'data', obrigatorio: false },
        { id: 'at_c31', nome: 'Observação Final', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Fora de garantia encerra o chamado',
      etapaOrigemId: 'at_e2',
      condicao: { campoId: 'at_c10', operador: 'igual', valor: 'Não' },
      etapaDestinoId: 'at_e6',
      etapaDestinoSenaoId: 'at_e3',
    },
    {
      tipo: 'mover',
      nome: 'Procedente vira reparo',
      etapaOrigemId: 'at_e3',
      condicao: { campoId: 'at_c14', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'at_e4',
      etapaDestinoSenaoId: 'at_e6',
    },
    {
      tipo: 'mover',
      nome: 'Reparo concluído vai para o aceite',
      etapaOrigemId: 'at_e4',
      condicao: { campoId: 'at_c25', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'at_e5',
    },
    {
      tipo: 'mover',
      nome: 'Aceite do cliente encerra',
      etapaOrigemId: 'at_e5',
      condicao: { campoId: 'at_c26', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'at_e6',
      etapaDestinoSenaoId: 'at_e4',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Responsabilidade só quando procedente',
      etapaOrigemId: 'at_e3',
      condicao: { campoId: 'at_c14', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['at_c15', 'at_c18'],
    },
  ],
  cards: [
    { id: 'at_card1', titulo: 'Infiltração no teto do banheiro', etapaId: 'at_e4', etiquetas: ['Infiltração', 'Reincidente'], valores: { at_c1: 'Infiltração no teto do banheiro', at_c2: 'Edifício Prime', at_c3: 'Apto 704', at_c4: 'Ana Ribeiro', at_c7: 'Impermeabilização / Infiltração', at_c14: 'Sim', at_c15: 'Construtora', at_c18: 4200, at_c19: 'Sim' } },
    { id: 'at_card2', titulo: 'Porta do quarto empenada', etapaId: 'at_e3', valores: { at_c1: 'Porta do quarto empenada', at_c2: 'Vista Verde - Torre A', at_c3: 'Apto 302', at_c4: 'Carlos Menezes', at_c7: 'Esquadrias', at_c10: 'Sim' } },
    { id: 'at_card3', titulo: 'Fissura na parede da sala', etapaId: 'at_e2', valores: { at_c1: 'Fissura na parede da sala', at_c2: 'Alto da Serra', at_c3: 'Casa 18', at_c4: 'Juliana Prates', at_c7: 'Estrutura / Fissura', at_c13: 'Alta' } },
    { id: 'at_card4', titulo: 'Tomada sem energia na cozinha', etapaId: 'at_e5', valores: { at_c1: 'Tomada sem energia na cozinha', at_c2: 'Edifício Prime', at_c3: 'Apto 1102', at_c4: 'Rogério Lima', at_c7: 'Elétrica', at_c14: 'Sim', at_c15: 'Empreiteiro executor', at_c25: 'Sim' } },
    { id: 'at_card5', titulo: 'Piso soltando na varanda', etapaId: 'at_e6', etiquetas: ['Fora de Garantia'], valores: { at_c1: 'Piso soltando na varanda', at_c2: 'Vista Verde - Torre A', at_c3: 'Apto 108', at_c4: 'Sandra Vieira', at_c7: 'Revestimento / Piso', at_c10: 'Não', at_c29: 'Fora de garantia' } },
    { id: 'at_card6', titulo: 'Vazamento no registro da cozinha', etapaId: 'at_e1', valores: { at_c1: 'Vazamento no registro da cozinha', at_c2: 'Centro Clínico', at_c4: 'Condomínio', at_c7: 'Hidráulica' } },
  ],
  tour: [
    '🛠️ Garantia com laudo: cada chamado registra quem é o responsável pelo defeito.',
    '1️⃣ "Chamado": cliente, unidade, sistema afetado e foto do problema.',
    '2️⃣ "Triagem": fora do prazo de garantia? o card já encerra com o desfecho certo.',
    '3️⃣ "Vistoria": procedente ou não, e de quem é a responsabilidade — construtora, fornecedor ou uso indevido.',
    '4️⃣ "Execução": prazo do reparo vira cobrança automática no card.',
    '5️⃣ "Aceite": cliente não aprovou? volta para o reparo.',
    '📌 Marque "Reincidente" para achar defeito sistêmico do empreendimento.',
  ],
  etapasDicas: [
    { quemFaz: 'Atendimento / SAC', objetivo: 'Registrar o relato do cliente com foto desde o primeiro contato.' },
    { quemFaz: 'Assistência Técnica', objetivo: 'Checar prazo de garantia por sistema antes de mandar equipe.', automacoes: ['Já configurado: fora de garantia encerra direto'] },
    { quemFaz: 'Engenheiro / Técnico', objetivo: 'Emitir laudo com responsabilidade definida — é o que protege a construtora.', automacoes: ['Já configurado: improcedente encerra o chamado'] },
    { quemFaz: 'Equipe de Manutenção / Empreiteiro', objetivo: 'Executar dentro do prazo prometido ao cliente.' },
    { quemFaz: 'Assistência Técnica', objetivo: 'Fechar só com aceite do cliente por escrito.' },
    { quemFaz: 'Assistência Técnica', objetivo: 'Consolidar desfechos para revisar projeto e fornecedor.', conexoes: ['Ligue à "Execução de Obra" para corrigir a causa nas obras em andamento'] },
  ],
};

export const TEMPLATES_OBRAS: DefaultTemplate[] = [
  execucaoObra,
  medicaoEmpreiteiro,
  contratacaoEmpreiteiro,
  suprimentosObra,
  segurancaObra,
  assistenciaTecnicaObra,
];
